import('./bootstrap').catch((error) => console.error(error));
